import { call, put, takeLatest, delay, select } from 'redux-saga/effects';

import { createInvoice, createInvoiceFailure, createInvoiceSuccess } from '.';

import invoiceService from '../../../services/InvoiceService';
import { getInvoices } from '../subscriptions';

function* rootSaga() {
	yield takeLatest(createInvoice, createInvoiceSaga);
}

function* createInvoiceSaga({ payload }) {
	try {
		yield delay(300);
		const createdInvoice = yield call(invoiceService.create, payload);
		yield put(createInvoiceSuccess(createdInvoice));

		// reload invoices data in subscriptions
		const tableParams = yield select(({ subscriptions }) => subscriptions.invoices.tableParams);
		yield put(getInvoices({ ...tableParams }));
	} catch (error) {
		yield put(createInvoiceFailure(error));
	}
}

export default rootSaga;
